import * as React from 'react';

export function WhyNutrition() {
  return (
    <section className="edu-nutrition">
      <style>{`
        .edu-nutrition {
          padding: 72px 24px;
          background: #fff;
        }
        .edu-nutrition-inner {
          max-width: 720px;
          margin: 0 auto;
        }
        .edu-nutrition h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 8px;
          line-height: 1.3;
        }
        .edu-nutrition .accent {
          font-size: 22px;
          font-weight: 600;
          color: #1EAA25;
          margin: 0 0 28px;
        }
        .edu-nutrition p {
          font-size: 16px;
          color: #444;
          line-height: 1.7;
          margin: 0 0 20px;
        }
        .edu-nutrition .highlight {
          font-weight: 600;
          color: #1a1a1a;
        }
        .edu-impact-list {
          list-style: none;
          padding: 0;
          margin: 24px 0 0;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
        }
        .edu-impact-list li {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 15px;
          color: #333;
          padding: 10px 14px;
          background: #f0fdf0;
          border-radius: 8px;
        }
        .edu-impact-list li i {
          color: #1EAA25;
          font-size: 14px;
          flex-shrink: 0;
        }
        @media (max-width: 640px) {
          .edu-nutrition h2 {
            font-size: 24px;
          }
          .edu-impact-list {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
      <div className="edu-nutrition-inner">
        <h2>La escuela es la segunda casa.</h2>
        <p className="accent">Y en casa se come bien.</p>
        <p>
          Cada vez más instituciones educativas entienden que <span className="highlight">la alimentación saludable es parte de la formación</span>.
          Un comedor que ofrece frutas y verduras frescas no solo nutre: educa con el ejemplo.
        </p>
        <p>
          Los chicos que comen mejor, <span className="highlight">aprenden mejor</span>.
          Y las familias valoran las instituciones que se comprometen con su bienestar.
        </p>
        <ul className="edu-impact-list">
          <li><i className="fa fa-check-circle" /> Mejor concentración y rendimiento</li>
          <li><i className="fa fa-check-circle" /> Hábitos saludables desde temprano</li>
          <li><i className="fa fa-check-circle" /> Familias más conformes</li>
          <li><i className="fa fa-check-circle" /> Compromiso visible con la salud</li>
        </ul>
      </div>
    </section>
  );
}
